(function(){
const popupId='VertigoPremiumPopup';
const key='vertigoPremiumPopupUntil';
const week=7*24*60*60*1000;
const month=30*24*60*60*1000;
const safeGet=()=>{try{return Number(localStorage.getItem(key))||0}catch(e){return 0}};
const safeSet=duration=>{try{localStorage.setItem(key,String(Date.now()+duration))}catch(e){}};
function init(){
  const popup=document.getElementById(popupId);
  if(!popup || typeof popup.showModal!=='function' || window.Shopify?.designMode)return;
  if(safeGet()>Date.now())return;
  let joined=false;
  const opener=window.setTimeout(()=>{
    if(popup.isConnected && !popup.open && !document.hidden && safeGet()<=Date.now()){
      popup.showModal();
    }
  },Math.max(0,Number(popup.dataset.delay)||5000));
  const dismiss=()=>{
    if(popup.open)popup.close();
    else safeSet(week);
  };
  popup.querySelector('[data-vpp-close]')?.addEventListener('click',dismiss);
  popup.addEventListener('click',event=>{if(event.target===popup)dismiss()});
  popup.querySelector('[data-vpp-join]')?.addEventListener('click',()=>{
    joined=true;
    safeSet(month);
    window.setTimeout(()=>{if(popup.open)popup.close()},180);
  });
  popup.addEventListener('close',()=>{safeSet(joined?month:week)});
  window.addEventListener('pagehide',()=>window.clearTimeout(opener),{once:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();